module.exports = __webpack_public_path__ + "1.0/img/title-pre-sell.1eeb61a6.png";